/* eslint-disable no-case-declarations */
const INITIAL_STATE = {
  list: [],
  details: {} // deletar details, nao existira mais
};

const transformPlan = (plan, payload) => {
  const newPLan = { ...plan };
  newPLan.procedimentos = [...plan.procedimentos, payload.hash];
  return newPLan;
};

const transformPlansList = (list, payload) => {
  // const newList = { ...list }; // OLD
  const newList = list;

  if (!newList[payload.status]) newList[payload.status] = []

  newList[payload.status].push(payload);
  return newList;
};

export default (state = INITIAL_STATE, action) => {
  if(!action){
    return state;
  }
  switch (action.type) {
    case 'plans/CREATE':
      return {
        ...state,
        list: [...state.list, action.payload.hash],
        details: { ...state.details, [action.payload.hash]: { ...action.payload } }
      };

    case 'plans/CREATE_ME': // ao adicionar um novo plano, este novo objeto é adicionado à store existente
      return {
        ...state,
        list: transformPlansList(state.list, action.payload)
      };

    case 'plans/LIST_PLANS':
      return {
        ...state,
        data: [...action.payload],
        finished: action.payload.filter(plan => plan.finalizado),
        open: action.payload.filter(plan => !plan.finalizado)
      };

    case 'plans/OVERWRITE':
      return {
        ...state,
        ...action.payload.plans
      };

    case 'plans/OVERWRITE_ME': // ao entrar na tela, ele sobrescreve a lista que previamente poderia existir
      return {
        ...state,
        list: { ...action.payload }
      };

    case 'plans/LOAD_MORE':
      return {
        ...state,
        ...action.payload
      };

    case 'plans/CONCLUDE':
      return {
        ...state,
        details: {
          ...state.details,
          [action.payload]: {
            ...state.details[action.payload],
            finalizado: true
          }
        }
      };

    case 'procedure/CREATE':
      return {
        ...state,
        details: {
          ...state.details,
          [action.payload.parent]: transformPlan(
            state.details[action.payload.parent],
            action.payload
          )
        }
      };

    case 'procedure/DELETE':
      return {
        ...state,
        details: {
          ...state.details,
          [action.payload.parent]: {
            ...state.details[action.payload.parent],
            procedimentos: state.details[action.payload.parent].procedimentos.filter(
              procedure => procedure !== action.payload.hash
            )
          }
        }
      };

    default:
      return state;
  }
};
